import { Observable, Subject } from "rxjs";

export function observableToSubject<T = any>(obs: Observable<T>): Subject<T> {
  const subject = new Subject<T>();
  obs.subscribe(
    (x: T) => {
      subject.next(x);
    },
    (err: any) => {
      subject.error(err);
    },
    () => {
      subject.complete();
    }
  );
  return subject;
}
